import { default as logoGreyPng } from './png/logo-grey.png';
import { default as logoSmallPng } from './png/logo-small.png';
import { default as logoWhitePng } from './png/logo-white.png';
import { default as logoWithSloganPng } from './png/logo-with-slogan.png';
import { default as logoGrey } from './svg/logo-grey.svg';
import { default as logoSmall } from './svg/logo-small.svg';
import { default as logoWhite } from './svg/logo-white.svg';

export const svg = {
  logoGrey,
  logoSmall,
  logoWhite,
};

export const png = {
  logoWithSlogan: logoWithSloganPng,
  logoGrey: logoGreyPng,
  logoWhite: logoWhitePng,
  logoSmall: logoSmallPng,
};
